/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetAutomationQueryResponse,
  GetAutomationPathParams,
  GetAutomation404,
} from '../types/GetAutomation'

function getGetAutomationUrl({ id }: { id: GetAutomationPathParams['id'] }) {
  const res = {
    method: 'GET',
    url: `/api/v1/automations/automations/${id}/` as const,
  }
  return res
}

/**
 * @description ViewSet for managing automations.
 * Provides CRUD operations for automations with different serializers
 * for list, detail, and create/update operations.
 * @summary Get automation detail
 * {@link /api/v1/automations/automations/:id/}
 */
export async function getAutomation(
  { id }: { id: GetAutomationPathParams['id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetAutomationQueryResponse,
    ResponseErrorConfig<GetAutomation404>,
    unknown
  >({
    method: 'GET',
    url: getGetAutomationUrl({ id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
